import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { getIsMobileAppMode, scrollPageToTop } from '@taxfix/scouts-helpers'

import { useProfile } from '@/store/profile'
import { useEventTracking } from '@/telemetry'
import { track, TRACK_VIEW_PAGE } from '@/trackers'

import { useNavigationRequestListener } from '@/hooks/use-navigation-request-listener'
import { useUpdateReactNative } from '@/hooks/use-update-react-native'

interface LocationObserverProps {
    children: React.ReactElement
}

export const LocationObserver = ({ children }: LocationObserverProps) => {
    const { pathname } = useLocation()

    useTrackPageView()
    useNavigationRequestListener() // @TODO: Maybe there's a better place for it

    const { updateReactNative } = useUpdateReactNative()

    const isMobileAppMode = getIsMobileAppMode()

    useEffect(() => {
        scrollPageToTop()
    }, [pathname])

    useEffect(() => {
        if (!isMobileAppMode) return
        updateReactNative()
    }, [isMobileAppMode, pathname, updateReactNative])

    return children
}

interface IPrevLocationState {
    prevPathname: string
    prevHash: string
    prevSearch: string
}

const useTrackPageView = () => {
    const { capturePageView } = useEventTracking()
    const { pathname, hash, search } = useLocation()

    const [{ prevPathname, prevHash, prevSearch }, setPrevLocation] = useState<IPrevLocationState>({
        prevPathname: '',
        prevHash: '',
        prevSearch: '',
    })

    const { profile } = useProfile()

    useEffect(() => {
        if (prevPathname === pathname && prevHash === hash && prevSearch === search) return

        setPrevLocation({ prevPathname: pathname, prevHash: hash, prevSearch: search })

        track(TRACK_VIEW_PAGE, { profile, pathname, hash, search })

        capturePageView()
    }, [pathname, hash, search, prevPathname, prevHash, prevSearch, profile, capturePageView])
}
